import { render, staticRenderFns } from "./LeaveActionComponent.vue?vue&type=template&id=7d71f136&scoped=true"
import script from "./LeaveActionComponent.vue?vue&type=script&lang=js"
export * from "./LeaveActionComponent.vue?vue&type=script&lang=js"
import style0 from "./LeaveActionComponent.vue?vue&type=style&index=0&id=7d71f136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71f136",
  null
  
)

export default component.exports